import { Component, Input, OnInit } from "@angular/core";
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";
import DataLabelsPlugin from "chartjs-plugin-datalabels";

@Component({
  selector: "lib-dougnhut-chart",
  templateUrl: "./dougnhut-chart.component.html",
})
export class DougnhutChartComponent implements OnInit {
  @Input() labelList: Array<any>;
  @Input() chartName: string;
  @Input() colors: any;
  @Input() dataList: any;

  chartTitle: string;

  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
        text: "Hola",
        align: "center",
      },
      legend: {
        display: false,
      },
      datalabels: {
        formatter: (value, context) => value + "%",
        anchor: "center",
        color: "white",
        align: "center",
        font: {
          weight: "bold",
          size: 12,
        },
      },
      tooltip: {
        backgroundColor: "rgba(24, 77, 57, 1)",
        borderColor: "#184d39",
        borderWidth: 2,
        caretPadding: 10,
        displayColors: false,
        enabled: true,
        intersect: true,
        padding: {
          x: 6,
          y: 6,
        },
        callbacks: {
          title: function () {
            return "";
          },
          label: function (context) {
            const datasetLabel = context.label || "";
            return datasetLabel + ": " + context.raw + "%";
          },
        },
      },
    },
  };

  public doughnutChartLabels: string[] = [];
  public doughnutChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [],
  };
  public doughnutChartType: ChartType = "doughnut";
  public doughnutChartColors = [];
  DataLabelsPlugin: any = DataLabelsPlugin;

  constructor() {}

  ngOnInit() {
    this.doughnutChartData = {
      labels: this.labelList,
      datasets: [
        {
          data: this.dataList.slice(0, 2),
          backgroundColor: this.colors.backgroundColor,
          borderColor: "#FFF",
        },
      ],
    };
    this.doughnutChartOptions.plugins.title.text = this.dataList[2];
    this.chartTitle = this.dataList[2];
  }
}
